module.exports = __webpack_public_path__ + "static/media/BodyRelaxationTechniques.1d839d96.png";